import { PaymentStrategyType, PaymentType } from '../api/payment/model'

export function getPaymentLabelByStrategyAndType(
  formattedAmount: string,
  paymentType: PaymentType,
  paymentStrategyType: PaymentStrategyType,
  separator = 'per' // 'per' or '/'
): string {
  const strategyLabel =
    paymentStrategyType === PaymentStrategyType.PARTYSIZE
      ? `${separator} person`
      : paymentStrategyType === PaymentStrategyType.BOOKING
      ? `${separator} booking`
      : ''

  const labelForDepositsOnly =
    paymentType === PaymentType.DEPOSIT ? 'deposit ' : ''

  return `${formattedAmount} ${labelForDepositsOnly}${strategyLabel}`.trim()
}
